import { FC } from 'react';
import { Button, Result } from 'antd';
import { useAuth } from '@/features/auth';
import { useFullScreenLoaderContext } from '@/shared/ui';
import { didTokenExpire } from '@/shared/utils';

type Props = {
  error: any;
  resetErrorBoundary: () => void;
};

export const ErrorPage: FC<Props> = ({ error, resetErrorBoundary }) => {
  const { showLoader } = useFullScreenLoaderContext();
  const { accessToken, refetchAccessToken } = useAuth();
  console.log('ERROR', error);

  if (
    accessToken &&
    (error?.status === 401 ||
      error?.status === 403 ||
      error?.stack.statusCode === 401 ||
      error?.stack.statusCode === 403 ||
      error.response?.status === 401 ||
      error.response?.status === 403)
  ) {
    if (didTokenExpire(accessToken)) {
      refetchAccessToken();
      showLoader();
    }
  }

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Result
        status="500"
        title="Sorry, something went wrong."
        subTitle={<span>Use button below to go back to home page.</span>}
        extra={
          <Button
            type="primary"
            onClick={() => {
              resetErrorBoundary();
              location.href = '/';
            }}
          >
            Go back home
          </Button>
        }
      />
    </div>
  );
};
